// extracted by mini-css-extract-plugin
export default {"wrapper":"J3-z","play":"K3-z"};